import { ITransferMajorsDatasource } from './../../datasources/transfer_majors_datasource';
import { TransferCreditsProgressState } from './../../progression/transfer_credits_progress_state';
import { Major } from '../../builders/major_builder';
import { IMemberDatasource, MemberDatasource } from './../../../global/datasources/member_datasource';
import { SelectionListServant } from './../../../global/servants/selection_list_servant';
import { ICommand } from '../../../../vendor/core-ts-types/dist/main';
import { IProgression } from 'utility-js-progression';
import { TransferMajorsCategorizedQuery } from '../../queries/transfer_majors_categorized_query';
import { TransferMajorsFoundQuery } from '../../queries/transfer_majors_found_query';
import { NO_RESULTS, ONE_RESULT, SOME_RESULTS, MORE_RESULTS } from '../../../global/strategies/search_results_strategy';

export class TransferCreditsChooseMajorController {
  model: {
    config: IMemberDatasource;
  };

  searchMajorsNoResultsMsg: string;
  dropdownHeaderMessage = '';

  constructor(
    $scope: any,
    ngMemberDatasource: MemberDatasource,
    private ngTransferMajorsDatasource: ITransferMajorsDatasource,
    private ngTransferCreditsProgression: IProgression,
    private ngTransferCreditsProgressState: TransferCreditsProgressState,
    private ngTransferMajorsFoundQuery: TransferMajorsFoundQuery,
    private ngTransferMajorsCategorizedQuery: TransferMajorsCategorizedQuery,
    private ngSelectionListServant: SelectionListServant,
    private searchTransferMajorsCommand: ICommand,
    private selectTransferMajorCommand: ICommand,
    private $element: ng.IAugmentedJQuery
  ) {
    this.model = {
      config: ngMemberDatasource.read()
    };
  }

  onSearchChange(event: any): void {
    this.searchTransferMajorsCommand(event.detail.value).then((results: any): void => {
      // TODO clean this up
      if (_.isEmpty(this.ngTransferMajorsFoundQuery.result.majors)) {
        this.dropdownHeaderMessage = NO_RESULTS;
      } else if (this.hasAllMajorsSelected()) {
        this.dropdownHeaderMessage = `You have selected 3 majors. Remove a major to make a different selection.`;
      } else if (this.ngTransferMajorsFoundQuery.result.hasMore) {
        this.dropdownHeaderMessage = MORE_RESULTS;
      } else if (this.ngTransferMajorsFoundQuery.result.majors.length === 1) {
        this.dropdownHeaderMessage = ONE_RESULT;
      } else {
        this.dropdownHeaderMessage = `${this.ngTransferMajorsFoundQuery.result.majors.length} ` + SOME_RESULTS;
      }
    });
  }

  majorSelectionChanged(event: any): void {
    this.selectTransferMajorCommand({
      id: event.detail.value
    }).then(() => {
      this.$element.find('hi-typeahead')[0]['searchValue'] = '';
    });
  }

  selectionStatus(): string {
    return this.ngTransferCreditsProgression.queryItemByKey('major').status();
  }

  hasAllMajorsSelected(): boolean {
    return this.ngSelectionListServant.isFull(this.ngTransferMajorsDatasource.model.majorsSelection);
  }
}

angular
  .module('capability-ng-transfer')
  .controller('ngTransferCreditsChooseMajorController', TransferCreditsChooseMajorController);



// WEBPACK FOOTER //
// ./app/lib/transfer/views/choose_major/choose_major.ts